<template>
  <div class="button-consoles">
    <div class="row button-row">
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-o')" type="button"
          class="btn  btn-primary btn-open">Open</button>
      </div>
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-v')" type="button"
          class="btn  btn-primary btn-vent-close">Vent Close</button>
      </div>
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-c')" type="button"
          class="btn  btn-primary btn-close">Close</button>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-1')" type="button"
          class="btn  btn-primary btn-preset btn-preset-1">Preset 1</button>
      </div>
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-2')" type="button"
          class="btn  btn-primary btn-preset btn-preset-2">Preset 2</button>
      </div>
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-3')" type="button"
          class="btn  btn-primary btn-preset btn-preset-3">Preset 3</button>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <button @click="sendEvent('group-2', 'g2-m')" type="button"
          class="btn btn-secondary btn-mode">Mode</button>
      </div>
    </div>
  </div>
</template>

<script>
import Particle from 'particle-api-js';

export default {
  name: 'Hatcg2',
  components: {},
  data() {
    return {
      token: String,
      particle: null,
    };
  },
  mounted() {
    this.initParticle();
  },
  methods: {
    initParticle() {
      this.particle = new Particle();
      this.loginToParticle();
    },
    loginToParticle() {
      this.particle.login({ username: 'jimmystranger89@gmail.com', password: 'Stranger3' }).then(
        (data) => {
          this.token = data.body.access_token;
        }, (err) => {
          console.log('Could not log in.', err);
        },
      );
    },
    sendEvent(eventName, value) {
      console.log('send some event to particle');
      const publishEventPr = this.particle.publishEvent({
        name: eventName,
        data: JSON.stringify(value),
        auth: this.token,
      });
      publishEventPr.then(
        (data) => {
          if (data.body.ok) {
            console.log('Event published succesfully');
          }
        }, (err) => {
          console.log(`Failed to publish event: ${err}`);
        },
      );
    },
  },
};
</script>
<style scoped>
</style>
